// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wYFO","col":"styles_col__2f3RF"};